(function () {
  // ====== SELECTORI ======
  var FORM_SEL = 'form[action*="/cart/add"]';
  var BTN_SEL =
    'button[type="submit"][data-btn-addtocart],button[type="submit"][data-btn-addToCart],button[type="submit"],input[type="submit"]';

  function inProductCard(el) {
    return !!(
      el &&
      el.closest &&
      el.closest(
        '.product-item, .product-card, .card-product, .productGrid-item, .productListing-item, .halo-product-item, li.product, .product, .product-grid, .productGrid, .products-grid, .productListing'
      )
    );
  }

  function setBusy(node, busy) {
    if (!node) return;
    node.style.opacity = busy ? '0.7' : '';
    node.style.pointerEvents = busy ? 'none' : '';
  }

  async function cartAdd(variantId, qty) {
    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', String(qty));

    var res = await fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!res.ok) throw new Error('add_failed');
    return res.json();
  }

  async function cartGet() {
    var res = await fetch('/cart.js', { cache: 'no-store' });
    if (!res.ok) throw new Error('cart_failed');
    return res.json();
  }

  async function cartChange(lineKey, qty) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: Number(qty) })
    });
    if (!res.ok) throw new Error('change_failed');
    return res.json();
  }

  function updateCartCount(count) {
    document
      .querySelectorAll('[data-cart-count], .cartCount, .cart-count-bubble span')
      .forEach(function (el) {
        el.textContent = String(count);
      });
  }

  function softThemeCartRefresh() {
    try {
      if (window.Halo && window.Halo.cart && typeof window.Halo.cart.getCart === 'function') {
        window.Halo.cart.getCart();
      }
    } catch (e) {}
  }

  function getVariantIdFromForm(form) {
    var idEl = form.querySelector('input[name="id"], select[name="id"]');
    return idEl && idEl.value ? idEl.value : null;
  }

  function renderQtyUI(form, variantId, startQty) {
    if (!form || !variantId) return;

    var host =
      form.querySelector('.pr-qty') ||
      form.querySelector('.product-form__submit') ||
      form.querySelector(BTN_SEL);

    if (!host) return;

    if (host.__prQtyMounted) {
      var n0 = host.querySelector('.pr-qty__n');
      if (n0) n0.textContent = String(startQty);
      return;
    }
    host.__prQtyMounted = true;

    if (host.tagName && host.tagName.toLowerCase() === 'button') {
      var container = document.createElement('div');
      host.replaceWith(container);
      host = container;
    }

    host.innerHTML =
      '<div class="pr-qty" data-pr-variant="' + String(variantId) + '">' +
        '<button type="button" class="pr-qty__m" aria-label="Decrease">–</button>' +
        '<span class="pr-qty__n">' + (Number(startQty) || 1) + '</span>' +
        '<button type="button" class="pr-qty__p" aria-label="Increase">+</button>' +
      '</div>';

    var wrap = host.querySelector('.pr-qty');
    var minus = host.querySelector('.pr-qty__m');
    var plus = host.querySelector('.pr-qty__p');
    var num = host.querySelector('.pr-qty__n');
    var currentQty = Number(startQty) || 1;

    plus.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      (async function () {
        try {
          setBusy(wrap, true);
          await cartAdd(variantId, 1);
          currentQty += 1;
          num.textContent = String(currentQty);
          var c = await cartGet();
          updateCartCount(c.item_count || 0);
          softThemeCartRefresh();
        } finally {
          setBusy(wrap, false);
        }
      })();
    }, true);

    minus.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (currentQty <= 1) return;

      (async function () {
        try {
          setBusy(wrap, true);
          var cart = await cartGet();
          var item = (cart.items || []).find(function (it) {
            return Number(it.variant_id) === Number(variantId);
          });
          if (item && item.key) {
            await cartChange(item.key, item.quantity - 1);
            currentQty -= 1;
            num.textContent = String(currentQty);
            var c2 = await cartGet();
            updateCartCount(c2.item_count || 0);
            softThemeCartRefresh();
          }
        } finally {
          setBusy(wrap, false);
        }
      })();
    }, true);
  }

  async function hydrateFromCart() {
    try {
      var cart = await cartGet();
      var map = new Map();
      (cart.items || []).forEach(function (it) {
        map.set(String(it.variant_id), it.quantity);
      });

      document.querySelectorAll(FORM_SEL).forEach(function (form) {
        if (!inProductCard(form)) return;
        var variantId = getVariantIdFromForm(form);
        if (!variantId) return;

        var qty = map.get(String(variantId));
        if (!qty) return;

        renderQtyUI(form, variantId, qty);
      });

      updateCartCount(cart.item_count || 0);
      softThemeCartRefresh();
    } catch (e) {
      console.warn(e);
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(FORM_SEL)) return;
    if (!inProductCard(form)) return;

    var variantId = getVariantIdFromForm(form);
    if (!variantId) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    (async function () {
      var btn = form.querySelector(BTN_SEL);
      try {
        setBusy(btn || form, true);
        await cartAdd(variantId, 1);
        renderQtyUI(form, variantId, 1);
        var c = await cartGet();
        updateCartCount(c.item_count || 0);
        softThemeCartRefresh();
      } catch (err) {
        console.warn(err);
      } finally {
        setBusy(btn || form, false);
      }
    })();
  }, true);

  document.addEventListener('DOMContentLoaded', hydrateFromCart);
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) hydrateFromCart();
  });

  setTimeout(hydrateFromCart, 800);
  setTimeout(hydrateFromCart, 1600);

  document.addEventListener('shopify:section:load', hydrateFromCart);

  var mo = new MutationObserver(function () {
    var need = false;
    document.querySelectorAll(FORM_SEL).forEach(function (f) {
      if (!f.__prHydrated) {
        f.__prHydrated = true;
        need = true;
      }
    });
    if (need) hydrateFromCart();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
